import { CloseCircleFill, EditSOutline, SystemQRcodeOutline } from "antd-mobile-icons";
import React, { useEffect, useMemo, useState } from "react";
import modStyl from './signAgreementLink.module.scss'
import storageX from "../../../utils/storageX";
import { BASE_URL } from "../../../config/config";
import { QRCodeCanvas } from "qrcode.react";
import { Modal } from "antd-mobile";
import { SignState } from "../../../api/data";
import Preview from "../../../component/preview/Preview";

type SignAgreementLinkProps = {
  onReload: ()=> void;
  subjectsData: {
    code: string;
    state: string;
    agreementUrl: string| null;
    signatureState: number;
  }
}

const SignAgreementLink: React.FC<SignAgreementLinkProps> = ({onReload, subjectsData})=> {
  const url = useMemo(()=> {
    const { protocol } = window.location
    const prefix = protocol === 'https:' ? '/wechat' : ''
    return `${prefix}/#/signAgreement/${subjectsData.code}`
  }, [subjectsData.code])

  const [signatureState, setSignatureState] = useState(SignState.None)
  const targetName = sessionStorage.getItem('targetName') || '受试者'
  useEffect(()=> {
    setSignatureState(subjectsData.signatureState)
  }, [subjectsData.signatureState])

  // 
  const makeQRUrl = ()=> {
    const { origin } = new URL(BASE_URL)
    const params = new URLSearchParams()

    const tenantCode = storageX().user().tenantCode

    params.set('fromUrlFromH5', '/epro/patient/signAgreement')
    params.set('toBeforeH5Url', '1')
    params.set('subjectCode', subjectsData.code)
    params.set('from', 'EPRO_PT')
    params.set('tenantCode', tenantCode)
    // params.set('randomCode', '')

    return `${origin}/wechat-applet-epro/epro?${decodeURIComponent(params.toString())}`
  }

  const [visible, setVisible] = useState(false)

  return (
    <>
      {
        SignState.Examinee === signatureState && (
          <a href={url} className={modStyl.btn}><EditSOutline/>医生签署</a>
        )
      }
      {
        SignState.None === signatureState && (
          <button onClick={()=> setVisible(true)} type="button" className={`${modStyl.btn} ${modStyl.lightBtn}`}><SystemQRcodeOutline/>患者签署</button>
        )
      }
      {
        SignState.All === signatureState && subjectsData.agreementUrl && (
          <Preview url={subjectsData.agreementUrl}/>
        )
      }

      <Modal onClose={()=> setVisible(false)} visible={visible}>
        <div className={modStyl.wrapper}>
          <div className={modStyl.area}>
            <div className={modStyl.tips}>{targetName}使用微信扫一扫进行协议签署</div>
            <div className={modStyl.corner}>
              <QRCodeCanvas value={makeQRUrl()} size={128}/>
            </div>
          </div>
          <button onClick={()=> {
            setVisible(false)
            onReload()
          }} type="button" className={modStyl.close}>
            <CloseCircleFill/>
          </button>
        </div>
      </Modal>
    </>
  )
}

export default SignAgreementLink